import HttpService from '@src/utils/http';
import { JsBridge, ActStat } from '@ie-activity/oversea-act-js-lib'
let http = new HttpService();

export const getInviteActivityInfoByActId = async (data) => {
  let res = await http.get('/activity/activity-invite/getInviteActivityInfoByActId', data);
  if (res.code === '2000') {
    return res
  } else if (res.code === 'failed' && res.message === 'Network Error') {
    return res
  }
  return null;
}

export const getDetailRank = async (data) => {
  let res = await http.get('/activity/activity-score/detailRank', data);
  if (res.code === '2000') {
    return res.data;
  } else if (res.code === 'failed' && res.message === 'Network Error') {
    return res
  }
  return null;
};

export const getShareScoreRecord = async (data) => {
  let res = await http.get('/activity/activity-score/shareScoreRecord', data)
  if (res.code === '2000') {
    return res;
  } else if (res.code === 'failed' && res.message === 'Network Error') {
    return res
  }
  return null;
}

export const getUserApply = async (activityId, data) => {
  let res = await http.get(`/activity/activity-score/userApply/${activityId}`, data);
  if (res.code === '2000') {
    return res.data;
  } else if (res.code === 'failed' && res.message === 'Network Error') {
    return res
  }
  return null;
}
export const getInviteRelation = async (data) => {
  let res = await http.get('/activity/activity-invite/getInviteRelation', data);
  if (res.code === '2000') {
    return res.data;
  } else if (res.code === '2001') {
    JsBridge.doLogin();
  }
  return null;
}



// WEBPACK FOOTER //
// ./src/pages/index/scripts/services.js